import { FeatureFlagName } from 'shared/enums';

export type OttoLabsClinicSetting = {
  label: string;
  description: string;
};

type OttoLabsClinicSettingMap = Partial<
  {
    [K in keyof typeof FeatureFlagName]: OttoLabsClinicSetting;
  }
>;

export const ottoLabsClinicSettingsMap: OttoLabsClinicSettingMap = {
  [FeatureFlagName.SortConversationByLastMessage]: {
    label: 'Reduce Conversation Movement',
    description:
      'Stop the following activity from moving a conversation up the list: conversation status changes, individual automation steps being completed, and tags/assignees/clients being added or removed. Turning this on should increase the chance that a conversation at the top of the list is more actionable.',
  },
  [FeatureFlagName.FlowAppointmentCreationPimsWriteback]: {
    label: 'Flow Appointment Write Back',
    description: 'Appointments created in Otto Flow will write back to your PIMS.',
  },
};
